var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 4.922c.042-1.266.01-2.625.005-2.672H5.592c0 .047-.037 1.406.005 2.672H2.25c0 3.187.464 4.795.984 5.939.52 1.144 1.238 2.123 2.752 3.295 1.41 1.092 4.477 2.513 4.889 2.7v1.327c-.216.469-1.102 1.322-3.905 1.322H6v2.25h12v-2.25h-1.205c-2.845 0-3.515-.896-3.67-1.322v-1.327c.436-.215 3.792-1.889 4.894-2.695 1.181-.863 2.386-2.414 2.751-3.295.366-.882.98-3.038.98-5.944h-3.375ZM5.137 9.932c-.412-.852-.656-1.776-.735-2.9h1.345c.033.28.066.529.108.763.31 1.838.693 3.29 1.204 4.524a6.724 6.724 0 0 1-1.921-2.386Zm13.726 0a6.772 6.772 0 0 1-1.95 2.405c.515-1.228.89-2.662 1.209-4.542.037-.234.075-.482.108-.764h1.373c-.084 1.125-.323 2.049-.74 2.902Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.39b59290.svg";
export { ForwardRef as ReactComponent };